import { Fragment } from "react";
import { SubNavigation } from "@common/Navigation/SubNavigation";
import { Trans, useTranslation } from "react-i18next";
import { SelectYourNumber } from "@common/SelectYourNumber/SelectYourNumber";
import { useUsage } from "@features/Usage/hook/useUsage";
import "@features/Usage/css/Usage.scss";
import { UsageSummary } from "@features/Usage/UsageSummary";
import { UsageDetailList } from "@features/Usage/UsageDetailList";
import { UsageFilter } from "@features/Usage/UsageFilter";
import { Card, CardContent, Grid, Typography } from "@mui/material";

export const UsagePage = () => {
    const {
        fromToDate,
        selectedPageSize,
        onPageSizeChange,
        selectedTimePeriod,
        selectedType,
        getUsageTypeListState,
        usageTypeList,
        onSelectedTypeChange,
        getUsageTypeList,
        getUsageSummaryState,
        usageSummaryList,
        timeFilterOptions,
        onTimePeriodChange,
        usageDetailList,
        getUsageDetailListState,
        currentPage,
        setCurrentPage,
        totalPages,
        refreshUsageDetailList,
        refreshUsageSummary,
    } = useUsage();
    const { startDate, endDate } = fromToDate;
    const { t } = useTranslation(["navigation", "usage"]);

    return (
        <Fragment>
            <SubNavigation />
            <div className="container-boxed">
                <Typography align="center" className="container-boxed__title" color="secondary" variant="h1">
                    {t("navigation:myUsage")}
                </Typography>
                <SelectYourNumber titleContent={t("usage:usageFor")}>
                    <Grid container direction="column" spacing={5}>
                        <Grid item>
                            <Card elevation={2}>
                                <CardContent>
                                    <Typography align="center" color="primary" variant="h2">
                                        {t("usage:detailedUsage")}
                                    </Typography>
                                    <div className="usage-interval">
                                        {!getUsageSummaryState.isLoading && !getUsageSummaryState.error && (
                                            <Typography color="secondary" variant="normal">
                                                <Trans
                                                    components={{ 1: <strong className="date-interval" /> }}
                                                    i18nKey="usageInterval"
                                                    ns="usage"
                                                    values={{ startDate, endDate }}
                                                />
                                            </Typography>
                                        )}
                                    </div>
                                    <UsageFilter
                                        getUsageTypeList={getUsageTypeList}
                                        getUsageTypeListState={getUsageTypeListState}
                                        selectedTimePeriod={selectedTimePeriod}
                                        selectedType={selectedType}
                                        timeFilterOptions={timeFilterOptions}
                                        usageTypeList={usageTypeList}
                                        onSelectedTypeChange={onSelectedTypeChange}
                                        onTimePeriodChange={onTimePeriodChange}
                                    />
                                    <UsageSummary
                                        getUsageSummaryState={getUsageSummaryState}
                                        refreshUsageSummary={refreshUsageSummary}
                                        selectedTimePeriod={selectedTimePeriod}
                                        usageSummaryList={usageSummaryList}
                                    />
                                    <UsageDetailList
                                        currentPage={currentPage}
                                        getUsageDetailListState={getUsageDetailListState}
                                        refreshUsageDetailList={refreshUsageDetailList}
                                        selectedPageSize={selectedPageSize}
                                        setCurrentPage={setCurrentPage}
                                        totalPages={totalPages}
                                        usageDetailList={usageDetailList}
                                        onPageSizeChange={onPageSizeChange}
                                    />
                                </CardContent>
                            </Card>
                        </Grid>
                        <Grid className="legal" item>
                            <Typography color="secondary" variant="caption">
                                {t("usage:legalMention")}
                            </Typography>
                            <Typography color="secondary" variant="caption">
                                {t("usage:VAT")}
                            </Typography>
                            <Typography color="secondary" variant="caption">
                                {t("usage:accuracy")}
                            </Typography>
                        </Grid>
                    </Grid>
                </SelectYourNumber>
            </div>
        </Fragment>
    );
};
